(function () {
  'use strict';

  function enhanceTabs(root) {
    root.querySelectorAll('[data-mep-tabs]').forEach(function (tabs, tabsetIndex) {
      if (tabs.dataset.mepReady === 'true') return;

      var tablist = tabs.querySelector('[data-mep-tablist]');
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-mep-tab]'));
      var panels = Array.prototype.slice.call(tabs.querySelectorAll('[data-mep-panel]'));
      if (!tablist || !buttons.length || !panels.length) return;

      tabs.dataset.mepReady = 'true';
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-label', tablist.dataset.label || 'Professional contributions');

      function activate(button, moveFocus) {
        var target = button.getAttribute('data-mep-tab');

        buttons.forEach(function (item) {
          var selected = item === button;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.setAttribute('tabindex', selected ? '0' : '-1');
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-mep-panel') !== target;
        });

        if (moveFocus) button.focus();
      }

      buttons.forEach(function (button, index) {
        var target = button.getAttribute('data-mep-tab');
        var panel = panels.find(function (candidate) {
          return candidate.getAttribute('data-mep-panel') === target;
        });
        var prefix = root.id || 'mnt-expert-profile';
        var tabId = prefix + '-tab-' + tabsetIndex + '-' + index;
        var panelId = prefix + '-panel-' + tabsetIndex + '-' + index;

        button.setAttribute('type', 'button');
        button.setAttribute('role', 'tab');
        button.id = tabId;

        if (panel) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
          panel.id = panelId;
          button.setAttribute('aria-controls', panelId);
        }

        button.addEventListener('click', function () {
          activate(button, false);
        });

        button.addEventListener('keydown', function (event) {
          var current = buttons.indexOf(button);
          var next = current;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;

          if (next !== current) {
            event.preventDefault();
            activate(buttons[next], true);
          }
        });
      });

      activate(buttons[0], false);
    });
  }

  function positiveInteger(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function enhanceLoadMore(root) {
    root.querySelectorAll('[data-mep-load-group]').forEach(function (group) {
      if (group.dataset.mepLoadReady === 'true') return;

      var list = group.querySelector('[data-mep-load-list]');
      var controls = group.querySelector('[data-mep-load-controls]');
      var button = group.querySelector('[data-mep-load-more]');
      var label = group.querySelector('[data-mep-load-label]');
      var status = group.querySelector('[data-mep-load-status]');
      if (!list || !controls || !button || !label || !status) return;

      var items = Array.prototype.slice.call(list.querySelectorAll('[data-mep-load-item]'));
      var initial = positiveInteger(list.dataset.mepLoadInitial, 3);
      var step = positiveInteger(list.dataset.mepLoadStep, 7);
      var visibleCount = Math.min(initial, items.length);

      group.dataset.mepLoadReady = 'true';

      function update(announce) {
        items.forEach(function (item, index) {
          item.hidden = index >= visibleCount;
        });

        var remaining = Math.max(items.length - visibleCount, 0);
        var nextCount = Math.min(step, remaining);

        if (items.length <= initial) {
          controls.hidden = true;
          status.textContent = '';
          return;
        }

        controls.hidden = false;
        button.hidden = remaining === 0;

        if (remaining > 0) {
          label.textContent = 'Load ' + nextCount + ' more article' + (nextCount === 1 ? '' : 's');
          button.setAttribute('aria-label', label.textContent + '; ' + remaining + ' remaining');
          status.textContent = visibleCount + ' of ' + items.length + ' articles shown.';
        } else {
          status.textContent = 'All ' + items.length + ' articles shown.';
        }

        if (announce && remaining === 0) {
          status.setAttribute('tabindex', '-1');
          status.focus();
        }
      }

      button.addEventListener('click', function () {
        visibleCount = Math.min(visibleCount + step, items.length);
        update(true);
      });

      update(false);
    });
  }

  function enhanceJumpNavigation(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-mep-jump] a[href^="#"]'));
    if (!links.length || !('IntersectionObserver' in window)) return;

    var linkById = {};
    links.forEach(function (link) {
      linkById[link.getAttribute('href').slice(1)] = link;
    });

    var sections = Object.keys(linkById).map(function (id) {
      return document.getElementById(id);
    }).filter(Boolean);

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries
        .filter(function (entry) { return entry.isIntersecting; })
        .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });

      if (!visible.length) return;
      links.forEach(function (link) { link.removeAttribute('aria-current'); });
      var active = linkById[visible[0].target.id];
      if (active) active.setAttribute('aria-current', 'true');
    }, {
      rootMargin: '-18% 0px -64% 0px',
      threshold: [0, 0.15, 0.35]
    });

    sections.forEach(function (section) { observer.observe(section); });
  }

  function enhanceMobileCta(root) {
    var mobileCta = root.querySelector('[data-mep-mobile-cta]');
    var hero = root.querySelector('.mep-hero');
    var finalCta = root.querySelector('[data-mep-final-cta]');
    if (!mobileCta || !hero || !finalCta || !('IntersectionObserver' in window)) return;

    var visibility = { hero: true, final: false };

    function update() {
      var hidden = visibility.hero || visibility.final;
      var controls = mobileCta.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      mobileCta.classList.toggle('is-hidden', hidden);
      mobileCta.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      controls.forEach(function (control) {
        if (hidden) {
          if (!control.hasAttribute('data-mep-original-tabindex')) {
            control.setAttribute('data-mep-original-tabindex', control.getAttribute('tabindex') || '');
          }
          control.setAttribute('tabindex', '-1');
        } else {
          var original = control.getAttribute('data-mep-original-tabindex');
          if (original === '') control.removeAttribute('tabindex');
          else if (original !== null) control.setAttribute('tabindex', original);
          control.removeAttribute('data-mep-original-tabindex');
        }
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) visibility.hero = entry.isIntersecting;
        if (entry.target === finalCta) visibility.final = entry.isIntersecting;
        update();
      });
    }, { threshold: 0.1 });

    update();
    observer.observe(hero);
    observer.observe(finalCta);
  }

  function enhance(root) {
    if (!root || root.dataset.mepEnhanced === 'true') return;
    root.dataset.mepEnhanced = 'true';
    root.classList.add('is-enhanced');
    document.body.classList.add('has-mnt-expert-profile');
    enhanceTabs(root);
    enhanceLoadMore(root);
    enhanceJumpNavigation(root);
    enhanceMobileCta(root);
  }

  function initialize(scope) {
    if (scope && scope.matches && scope.matches('[data-mep-root]')) enhance(scope);
    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('[data-mep-root]').forEach(enhance);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
